module.exports = __webpack_public_path__ + "img/wa.d89731b4.svg";